import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';

import i18n from 'src/i18n';
import { store } from 'src/store/store';
import App from 'src/App';
import reportWebVitals from 'src/reportWebVitals';
import { GlobalStyles } from 'src/GlobalStyles';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found in document.');
}

createRoot(container).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <GlobalStyles />
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <App />
        </BrowserRouter>
      </Provider>
    </I18nextProvider>
  </StrictMode>,
);

reportWebVitals();
